import React from 'react';
import styles from './WhereToBuy.module.css';

const CMS_BASE_URL = process.env.REACT_APP_CMS_BASE_URL;

const WhereToBuy = ({ storeData }) => {
  const stores = storeData && storeData.length > 0 ? storeData : [];

  return (
    <div className={styles.whereToBuyContainer}>
      <div className={styles.storeGrid}>
        {stores.map((store, index) => (
          <a
            key={index}
            href={store.url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.storeBox}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            {store.icon ? (
              <img
                src={`${CMS_BASE_URL}/attachments/${store.icon}`}
                alt={store.name || `Store ${index + 1}`}
                className={styles.storeImage}
                loading="lazy"
                width="96"
                height="84"
              />
            ) : (
              <span className={styles.storeText}>{store.text || store.name}</span>
            )}
          </a>
        ))}
      </div>
    </div>
  );
};

export default WhereToBuy;